import { render, staticRenderFns } from "./identifycode.vue?vue&type=template&id=3841812c&"
import script from "./identifycode.vue?vue&type=script&lang=js&"
export * from "./identifycode.vue?vue&type=script&lang=js&"
import style0 from "./identifycode.vue?vue&type=style&index=0&id=3841812c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports